import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationGroupList, getUserCommentAnalyse, getTagTypeList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import * as DateUtil from '@/utils/date';

var _this;

export default {
  name: 'BairunCommentAnalyse',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatTime: function formatTime(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'MM-dd hh:mm');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    },
    getStationGroupName: function getStationGroupName(stationGroupNo) {
      for (var i = 0; i < _this.stationGroupOptions.length; i++) {
        if (_this.stationGroupOptions[i].stationGroupNo === stationGroupNo) {
          return _this.stationGroupOptions[i].stationGroupName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getUserCommentAnalyse,
      stationOptions: [],
      stationTempOptions: [],
      stationGroupOptions: [],
      tagTypeOptions: [],
      searchTagType: '全部',
      searchText: '',
      searchDateTimeType: '今日',
      searchStartTime: '',
      searchEndTime: '',
      endTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          // return ture表示日期不可选
          return !DateUtil.isBeforeMonth(_this.searchStartTime, time.Format('yyyy-MM-dd hh:mm:ss'), 3);
        }
      },
      hasSearch: false,
      totalData: {
        commentOrderCount: 0,
        commentPointSum: 0,
        commentTagTypeList: []
      },
      tagData: [],
      stationSortData: []
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationGroupOptions, stationOptions, tagTypeOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getStationGroupList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                stationGroupOptions = _context3.sent;
                _this3.stationGroupOptions = stationGroupOptions.data.list;

                if (_this3.stationGroupOptions.length > 0) {
                  _this3.searchInfo.stationGroupNo = _this3.stationGroupOptions[0].stationGroupNo;
                }

                _context3.next = 7;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 7:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;
                _context3.next = 11;
                return getTagTypeList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 11:
                tagTypeOptions = _context3.sent;
                _this3.tagTypeOptions = tagTypeOptions.data.list;

                _this3.onChangeStationGroup();

                _this3.onSearchDateTimeTypeChange();

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onInputChange: function onInputChange() {
      this.$forceUpdate();
    },
    onChangeStationGroup: function onChangeStationGroup() {
      var _this4 = this;

      this.stationTempOptions = this.stationOptions.filter(function (item) {
        return item.stationGroupNo == _this4.searchInfo.stationGroupNo;
      });
      this.$forceUpdate();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit(dataType) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.page = 1;
                _this5.pageSize = 99999;

                if (_this5.searchTagType === '全部') {
                  _this5.searchInfo.commentTagType = 0;
                } else {
                  _this5.tagTypeOptions.forEach(function (item) {
                    if (_this5.searchTagType == item.commentTagTypeName) {
                      _this5.searchInfo.commentTagType = item.commentTagType;
                    }
                  });
                } // 全部更新


                if (dataType === -1) {
                  _this5.reloadTotalData();

                  _this5.reloadTagData();

                  _this5.reloadStationSortData();
                } // 更新油站排行


                if (dataType === 1) {
                  _this5.reloadStationSortData();
                } // 更新汇总统计


                if (dataType === 2) {
                  _this5.reloadTotalData();
                } // 更新标签统计


                if (dataType === 3) {
                  _this5.reloadTagData();
                }

                _this5.hasSearch = true;

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 更新汇总统计
    reloadTotalData: function reloadTotalData() {
      var _this6 = this;

      var defaultObj = {};
      defaultObj.commentOrderCount = 0;
      defaultObj.commentPointSum = 0;
      defaultObj.commentTagTypeList = [];
      this.tagTypeOptions.forEach(function (item) {
        defaultObj.commentTagTypeList.push({
          'commentTagTypeName': item.commentTagTypeName,
          'commentTagTypeCount': 0
        });
      });
      getUserCommentAnalyse(_objectSpread({
        dataType: 2
      }, this.searchInfo)).then(function (res) {
        _this6.totalData = res.data.list ? res.data.list[0] : defaultObj;
      });
    },
    // 更新标签统计
    reloadTagData: function reloadTagData() {
      var _this7 = this;

      getUserCommentAnalyse(_objectSpread({
        dataType: 3
      }, this.searchInfo)).then(function (res) {
        _this7.tagData = res.data.list ? res.data.list : [];
      });
    },
    // 更新油站排行
    reloadStationSortData: function reloadStationSortData() {
      var _this8 = this;

      getUserCommentAnalyse(_objectSpread({
        dataType: 1
      }, this.searchInfo)).then(function (res) {
        if (res.data.list) {
          res.data.list.forEach(function (item) {
            item.commentAvgPoint = parseFloat((item.commentPointSum / item.commentOrderCount).toFixed(2));
          });
          res.data.list.sort(function (x, y) {
            return y.commentAvgPoint - x.commentAvgPoint;
          });
          var sortIndex = 1;
          var beforeCommentAvgPoint = 0;
          res.data.list.forEach(function (item, index) {
            if (index == 0) {
              item.sortIndex = sortIndex;
              beforeCommentAvgPoint = item.commentAvgPoint;
            } else if (item.commentAvgPoint < beforeCommentAvgPoint) {
              sortIndex++;
              item.sortIndex = sortIndex;
            } else {
              item.sortIndex = sortIndex;
            }
          });
          _this8.stationSortData = res.data.list;
        } else {
          _this8.stationSortData = [];
        }
      });
    },
    onSearchDateTimeTypeChange: function onSearchDateTimeTypeChange() {
      console.log('onSearchDateTimeTypeChange');

      if (this.searchDateTimeType === '今日') {
        this.searchInfo.startTime = DateUtil.todayStartStr();
        this.searchInfo.endTime = DateUtil.todayEndStr();
        this.$set(this, 'searchStartTime', this.searchInfo.startTime);
        this.$set(this, 'searchEndTime', this.searchInfo.endTime);
      }

      if (this.searchDateTimeType === '昨日') {
        this.searchInfo.startTime = DateUtil.yesterdayStartStr();
        this.searchInfo.endTime = DateUtil.yesterdayEndStr();
        this.$set(this, 'searchStartTime', this.searchInfo.startTime);
        this.$set(this, 'searchEndTime', this.searchInfo.endTime);
      }

      if (this.searchDateTimeType === '本周') {
        this.searchInfo.startTime = DateUtil.weekStartStr();
        this.searchInfo.endTime = DateUtil.weekEndStr();
        this.$set(this, 'searchStartTime', this.searchInfo.startTime);
        this.$set(this, 'searchEndTime', this.searchInfo.endTime);
      }

      if (this.searchDateTimeType === '本月') {
        this.searchInfo.startTime = DateUtil.monthStartStr();
        this.searchInfo.endTime = DateUtil.monthEndStr();
        this.$set(this, 'searchStartTime', this.searchInfo.startTime);
        this.$set(this, 'searchEndTime', this.searchInfo.endTime);
      }

      if (this.searchDateTimeType === '本季') {
        this.searchInfo.startTime = DateUtil.quarterStartStr();
        this.searchInfo.endTime = DateUtil.quarterEndStr();
        this.$set(this, 'searchStartTime', this.searchInfo.startTime);
        this.$set(this, 'searchEndTime', this.searchInfo.endTime);
      }
    },
    onCustomDateTimeChange: function onCustomDateTimeChange() {
      console.log('onCustomDateTimeChange'); // 如果开始日期不在n个月范围内，则清空结束日期

      if (this.searchStartTime !== '' && !DateUtil.isBeforeMonth(this.searchStartTime, this.searchEndTime, 3)) {
        this.$set(this, 'searchEndTime', '');
      }

      if (this.searchStartTime !== '' && this.searchEndTime !== '') {
        this.searchDateTimeType = '';
        this.searchInfo.startTime = this.searchStartTime;
        this.searchInfo.endTime = this.searchEndTime;
      }

      this.$forceUpdate();
    }
  }
};